import { render, staticRenderFns } from "./dropImageUploader.vue?vue&type=template&id=5f67bf80&scoped=true"
import script from "./dropImageUploader.vue?vue&type=script&lang=js"
export * from "./dropImageUploader.vue?vue&type=script&lang=js"
import style0 from "./dropImageUploader.vue?vue&type=style&index=0&id=5f67bf80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f67bf80",
  null
  
)

export default component.exports